<template>
  <div class="home">

    <nav-bar showCert @onJump="onJump"></nav-bar>
    <div v-html="data.Content" class="detail"></div>


    <!--参与活动弹出-->
    <!--<van-action-sheet v-model="show" title=" ">-->
      <!--<div style="margin-top: 15px;padding: 10px">-->
        <!--<van-row>-->
          <!--<van-col span="8">-->
            <!--<img style="width: 100px;height: 80px;object-fit: cover" :src="data.PictureUrl"/>-->
          <!--</van-col>-->
          <!--<van-col span="16">-->
            <!--<div style="margin-left: 5px;">-->
            <!--<p style="font-weight: bold;margin-top: 0;margin-bottom: 5px">{{data.AdTitle}}</p>-->
            <!--<p style="font-size: 14px;margin: 0;"><span style="color: red">{{data.Price}}元</span>{{data.Desc}}</p>-->
            <!--</div>-->
          <!--</van-col>-->

        <!--</van-row>-->

        <!--<van-cell title="数量" :label="tip">-->
          <!--&lt;!&ndash; 使用 right-icon 插槽来自定义右侧图标 &ndash;&gt;-->
          <!--<van-stepper v-model="value" />-->
        <!--</van-cell>-->

        <!--<van-cell-group>-->
          <!--<van-field v-if="attendType==2"-->
                  <!--v-model="from.donationName"-->
                  <!--label="捐赠人"-->
                  <!--placeholder="捐赠人姓名(不填默认为爱心人士)"-->

          <!--/>-->
          <!--<van-field-->
                  <!--v-model="from.name"-->
                  <!--required-->
                  <!--clearable-->
                  <!--:label="attendType==2?'受捐人':'收件人'"-->
                  <!--:placeholder="attendType==2?'请输入受捐人姓名':'请输入收件人姓名'"-->

          <!--/>-->

          <!--<van-field-->
                  <!--v-model="from.phone"-->
                  <!--label="手机号"-->
                  <!--placeholder="请输入收件人手机号码"-->
                  <!--required-->
          <!--/>-->

          <!--<van-field-->
                  <!--readonly-->
                  <!--v-model="areaText"-->
                  <!--label="收件地区"-->
                  <!--placeholder="省市区"-->
                  <!--required-->
                  <!--@click="selectArea"-->
          <!--/>-->

          <!--<van-field-->
                  <!--type="textarea"-->
                  <!--v-model="from.address"-->
                  <!--label="详细地址"-->
                  <!--placeholder="请输入详细地址（精确到门牌号）"-->
                  <!--required-->
          <!--/>-->

          <!--<van-field-->
                  <!--type="textarea"-->
                  <!--v-model="from.remarks"-->
                  <!--label="备注"-->
                  <!--placeholder="(选填)"-->

          <!--/>-->
        <!--</van-cell-group>-->

        <!--<div style="margin-top: 40px">-->
        <!--<van-submit-bar-->
                <!--:loading="loading"-->
                <!--:price="getTotalPrice*100"-->
                <!--button-text="下一步"-->
                <!--@submit="onSubmit"-->

        <!--/>-->
        <!--</div>-->

      <!--</div>-->
    <!--</van-action-sheet>-->
    <van-action-sheet v-model="areaShow">
    <van-area
            :area-list="areaList"
            :columns-placeholder="['请选择', '请选择', '请选择']"
            title="选择地区"
            @confirm="areaConfirm"
            @cancel="areaShow=false"
    />

    </van-action-sheet>

    <van-sku
            v-model="show"
            :sku="sku"
            :goods="goods"
            :hide-stock="true"
            :goods-id="1"
            :show-add-cart-btn="false"
            :message-config="messageConfig"
            :initial-sku="{s1: '1',selectedNum:1,1:[1]}"
            @buy-clicked="onSubmit"
    >

      <template slot="sku-messages">


        <van-cell-group>
        <van-field v-if="attendType==2"
        v-model="from.donationName"
        label="捐赠人"
        placeholder="捐赠人姓名(不填默认为爱心人士)"

        />
        <van-field
        v-model="from.name"
        required
        clearable
        :label="attendType==2?'受捐人':'收件人'"
        :placeholder="attendType==2?'请输入受捐人姓名':'请输入收件人姓名'"

        />

        <van-field
        v-model="from.phone"
        label="手机号"
        placeholder="请输入收件人手机号码"
        required
        />

        <van-field
        readonly
        v-model="areaText"
        label="收件地区"
        placeholder="省市区"
        required
        @click="selectArea"
        />

        <van-field
        type="textarea"
        v-model="from.address"
        label="详细地址"
        placeholder="请输入详细地址（精确到门牌号）"
        required
        />

        <van-field
        type="textarea"
        v-model="from.remarks"
        label="备注"
        placeholder="(选填)"

        />
        </van-cell-group>
      </template>
    </van-sku>







    <div class="bottom">
    <div class="btn btn-color1" :class="{'btn-size-large':!isDonation}" @click="showDialog(1)">参与活动</div>
    <div class="btn btn-color2" v-if="isDonation" @click="showDialog(2)">我要捐赠</div>
    </div>
  </div>


</template>

<script>
    // @ is an alias to /src

    import NavBar from '@/components/NavBar'

    import areaData from '@/area'
    import bus from '@/bus'


    export default {
        name: 'home',
        components: {

            NavBar
        },
        data(){

            return{

                id:31,
                show:false,
                donationShow:false,
                value:1,
                tip:'',
                goods: {
                    // 默认商品 sku 缩略图
                    picture: ''
                },
                sku:{
                    tree:[{
                        k:'认购数量',
                        k_s:'s1',
                        v:[
                            {
                            id:'1',
                            name:'10斤红米'
                        },
                            {
                                id:'2',
                                name:'10斤优质米'
                            },
                            {
                                id:'3',
                                name:'10斤普通大米'
                            },
                        ]
                    }],
                    list: [
                        {
                            id: 1, // skuId
                            s1: '1', // 规格类目 k_s 为 s1 的对应规格值 id
                            price: 7000, // 价格（单位分）
                            stock_num: 99999 // 当前 sku 组合对应的库存
                        },
                        {
                            id: 2, // skuId
                            s1: '2', // 规格类目 k_s 为 s1 的对应规格值 id
                            price: 5000, // 价格（单位分）
                            stock_num: 99999 // 当前 sku 组合对应的库存
                        },
                        {
                            id: 3, // skuId
                            s1: '3', // 规格类目 k_s 为 s1 的对应规格值 id
                            price: 3500, // 价格（单位分）
                            stock_num: 99999 // 当前 sku 组合对应的库存
                        }
                    ],
                    price:'1',
                    stack_num:1000000,
                    node_sku:false,
                    messages: [
                        {
                            // 商品留言
                            datetime: '0', // 留言类型为 time 时，是否含日期。'1' 表示包含
                            multiple: '0', // 留言类型为 text 时，是否多行文本。'1' 表示多行
                            name: '留言', // 留言名称
                            type: 'text', // 留言类型，可选: id_no（身份证）, text, tel, date, time, email
                            required: '1', // 是否必填 '1' 表示必填
                            placeholder: '', // 可选值，占位文本
                            extraDesc: ''  // 可选值，附加描述文案
                        }
                    ]
                },
                messageConfig: {

                },
                from:{
                    donationName:'',
                    name:'',
                    phone:'',
                    province:'',
                    city:'',
                    county:'',
                    address:'',
                    type:'',
                    remarks:'' ,

                },
                areaList:[],
                areaShow:false,
                areaText:'',
                data:{},
                loading:false,
                attendType:1, //参加类型(1.正常参与,2.捐赠)
                isDonation:false,

            }
        },

        created(){

            this.areaList = areaData;
            if(this.$route.query.id){
                this.id = this.$route.query.id
            }

            let toast =  this.$toast.loading({
                mask: true,
                message: '加载中...'
            });
            this.$http.get('/GZFPOneMeters/ActDetail',{Id:this.id}).then(res=>{

                toast.clear();
                if(res.data.code===200){

                    this.data = res.data.data;

                    this.goods.picture=this.data.PictureUrl
                    this.isDonation = this.data.IsDonation
                    this.$store.commit('setLogoUrl',this.data.LogoUrl)
                    bus.$emit('setTitle',this.data.Title)

                }else {

                    this.$toast(res.data.message)
                }


            }).catch(err=>{
                toast.clear();
                this.$toast('获取活动失败')

            })


        },

        computed:{


            getTotalPrice(){


                let total =this.value*this.data.Price
                this.tip = total>10000?"已超过单笔支付限额，点击下一步按页面提示操作":''
                return total.toFixed(2);
            }

        },

        methods:{


            onJump(){

                this.$router.push({path:'search',query:{id:this.id}})
            },

            showDialog(type){

                this.attendType=type;

                //获取历史输入
                let item = localStorage.getItem('inputHistory');
                if(item){

                   let json = JSON.parse(item);
                   this.from.donationName = json.donationName;
                   this.from.name = json.name;
                   this.from.phone = json.phone;
                   this.from.address = json.address;
                   this.from.province = json.province;
                   this.from.city = json.city;
                   this.from.county = json.county;
                   this.areaText = this.from.province+'-'+this.from.city+'-'+this.from.county
                }

                this.show=true;

            },
            selectArea(){


                this.areaShow=true;
            },
            //判断是否微信客户端
            is_wx(){

                let ua = navigator.userAgent.toLowerCase();

                 return ua.match(/MicroMessenger/i) == "micromessenger";
            },
            areaConfirm(value){

                this.areaShow=false;


                if(value.length>0){

                    this.from.province = value[0].name;
                    this.from.city = value[1].name;
                    this.from.county = value[2].name;
                    this.areaText = this.from.province+'-'+this.from.city+'-'+this.from.county
                }

            },

            onSubmit(e){

                let remark = ""
                for(let item of this.sku.tree[0].v){

                    if(item.id===e.selectedSkuComb.s1){
                        remark = item.name
                    }
                }

                if(this.from.name.length===0){

                    this.$toast('请输入收件人姓名')
                    return;
                }
                if(this.from.phone.length===0){

                    this.$toast('请输入手机号码')
                    return;
                }

                if(!(/^1[3456789]\d{9}$/.test(this.from.phone))){
                    alert("手机号码有误，请重填");
                    return;
                }
                if(this.from.province.length===0){

                    this.$toast('请选择地区')
                    return;
                }

                if(this.from.address.length===0){

                    this.$toast('请输入详细地址')
                    return;
                }


                let channel = this.$route.query.channel||1;
                let code = this.$route.query.iq||'1SVZD8QX';

                this.loading =true;
                if(this.from.remarks){
                    remark = remark.concat(`(备注:${this.from.remarks})`);
                }
                this.$http.post('/GZFPOneMeters/Buy',{
                    ActivityId:this.data.Id,
                    UserId:0, //sessionStorage.getItem('userId'),
                    IsDonation:this.attendType===2,
                    DonationName:this.from.donationName===''?'爱心人士':this.from.donationName,
                    Name:this.from.name,
                    Phone:this.from.phone,
                    Province:this.from.province,
                    City:this.from.city,
                    County:this.from.county,
                    Address:this.from.address,
                    Num:e.selectedNum,
                    Price:(e.selectedSkuComb.price*e.selectedNum/100).toFixed(2),
                    ReferralCode:code,
                    Channel:channel,
                    Remark:remark
                }).then(res=>{

                    if(res.data.code===200) {
                        //记录用户输入
                        localStorage.setItem('inputHistory', JSON.stringify(this.from))

                        if (this.getTotalPrice <= 10000) {

                            //微信内打开使用jsapi支付

                               if(this.is_wx()){
                                location.href = this.$http.baseUrl + '/GZFPOneMeters/WXPay?OrderNo=' + res.data.data + '&WxReturnUrl=https://act.gzfp.org.cn/certificate&AppKey=c0ee26b6-40fb-422e-9847-6acb6cd6e936'

                            //微信外浏览器使用支付宝和微信h5支付
                            }else {

                                this.$router.push({path:'/pay',query:{orderNo: res.data.data,id:this.data.Id }})
                            }


                        } else {

                            this.$router.push({
                                path: '/about',
                                query: {
                                    title: this.data.AdTitle,
                                    num: this.value,
                                    total: this.getTotalPrice,
                                    url: this.data.PictureUrl
                                }
                            })
                        }
                    }else {

                        this.$toast(res.data.message)
                    }
                }).catch(err=>{

                    this.$toast('提交异常'+err)
                }).finally(()=>{
                    this.loading =false;
                })

            }

        }
    }
</script>


<style scoped>

  .detail{

    padding-top: 35px;

  }



  .bottom{

    width: 100%;
    position: fixed;
    bottom: 0;

  }



 .btn{

   width: 50%;
   color: white;
   line-height: 50px;
   text-align: center;
   display: inline-block;
 }

 .btn-size-large{

   width: 100%;
 }

  .btn-color1{

    background-color: rgba(157, 42, 50, 1);

  }

 .btn-color2{

   background-color:#DC143C;

 }


 .van-cell__label{

   color:red;
 }


 .van-button--danger {
   color: #fff;
   background-color: rgba(157, 42, 50, 1);
   border: 1px solid rgba(157, 42, 50, 1);
 }
 /*
 .van-submit-bar__price {
   color: rgba(157, 42, 50, 1);
   font-size: 18px;
 }
 */

</style>
